import React from 'react';
import { useTranslation } from 'react-i18next';
import { CopyOne } from '../Common/Common.styles';
import {
  TitleWrapper,
  TitleContainer,
  HeaderDescription,
  DagTitle,
  PageTitle,
} from './Header.styles';

type HeaderProps = {
  isNational: boolean;
  dag?: string;
  isFiltersOpen: boolean;
};

const Header: React.FC<HeaderProps> = ({ isNational, dag, isFiltersOpen }) => {
  const { t } = useTranslation();
  const dagName = dag?.split('(')[0];

  return (
    <TitleContainer isFiltersOpen={isFiltersOpen}>
      <TitleWrapper data-testid="header-title-wrapper">
        <PageTitle>{t('promo.header.store')}</PageTitle>
        <DagTitle data-testid="header-title">
          {isNational ? t('promo.header.national') : `${dagName} Audi Offers`}
        </DagTitle>
        <HeaderDescription>
          <CopyOne data-testid="header-body">
            {isNational ? t('promo.header.descriptionNational') : t('promo.header.description')}
          </CopyOne>
        </HeaderDescription>
      </TitleWrapper>
    </TitleContainer>
  );
};

export default Header;
